import { useLocation, matchPath } from 'react-router-dom';
import { paths } from '../paths';

// ----------------------------------------------------------------------

export function useActiveLink(path, deep = true) {
  const { pathname } = useLocation();

  // Match for exact paths or deep paths based on provided arguments
  const normalActive = path ? !!matchPath({ path, end: true }, pathname) : false;
  const deepActive = path ? !!matchPath({ path: `${path}/*`, end: false }, pathname) : false;

  // Handle the root dashboard highlighting for all dashboard paths
  if (path === paths.dashboard.root) {
    return (
      deepActive &&
      !pathname.startsWith(paths.dashboard.reports) &&
      !pathname.startsWith(paths.dashboard.settings)
    );
  }

  // Handle the reports dropdown highlighting
  if (path.includes(paths.dashboard.reports)) {
    return deepActive && pathname.startsWith(paths.dashboard.reports);
  }

  // Handle the settings dropdown highlighting
  if (path.includes(paths.dashboard.settings)) {
    return deepActive && pathname.startsWith(paths.dashboard.settings);
  }

  // Default return based on deep matching preference
  return deep ? deepActive : normalActive;
}
